import { useMemo } from 'react';
import { useAuthClaims } from '../../../hooks/useAuthClaims';
import { useLessonResponseToTableType } from '../../../hooks/useLessonResponseToTableType';
import { useSelectedSchoolYear } from '../../../hooks/useSelectedSchoolYear';
import { enrichLessons } from '../utils/enrichLessons';
import { useDeputateLessonsMutations } from './useDeputateLessonsMutations';
import { useDeputateLessonsQuery } from './useDeputateLessonsQuery';

type useLessonsProps = {
  organizationUuid?: string;
  schoolYearUuid?: string;
};

export function useDeputateLessons({ organizationUuid, schoolYearUuid }: useLessonsProps) {
  const { pimAuthClaims } = useAuthClaims();
  const schoolYear = useSelectedSchoolYear();

  const _organizationUuid = organizationUuid ?? pimAuthClaims.getOrganizationUuid();
  const _schoolYearUuid = schoolYearUuid ?? schoolYear?.uuid;

  const {
    lessons: lessonItems,
    people,
    deputateByTeachersData,
    refetchLessons,
  } = useDeputateLessonsQuery(_organizationUuid, _schoolYearUuid);

  const tableLessons = useLessonResponseToTableType({
    queryLessonsData: lessonItems,
    deputateByTeachersData,
    versionContext: false,
  });

  /** Vereinheitlichtes Array: LessonTableType-Felder + die Zuordnung des Backends für Formulare */
  const lessons = useMemo(() => enrichLessons(lessonItems, tableLessons), [lessonItems, tableLessons]);

  const mutations = useDeputateLessonsMutations(_schoolYearUuid, tableLessons, lessonItems);

  return {
    ...mutations,
    /** Vereinheitlichtes lessons-Array (LessonTableType + Zuordnung des Backends) */
    lessons,
    /** Alle Lehrkräfte – für Dropdowns */
    teachers: people,
    refetchLessons,
  };
}
